import { createSelector } from '@ngrx/store';
import { renewalsFeatureSelector } from '@app/state/app.selectors';

/* Selectors */
export const originalQuoteRequestIdSelector = createSelector(renewalsFeatureSelector, (state) => state.originalQuoteRequestId);
export const originalQuoteDueDateSelector = createSelector(renewalsFeatureSelector, (state) => state.originalQuoteDueDate);
